import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import {DrawerOption} from "./DropdownSingle.vue";
import RadioButton from "./RadioButton.vue";

interface Props {
  options: DrawerOption<U>[];
  vertical?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: /*@__PURE__*/_mergeModels({
    options: {},
    vertical: { type: Boolean }
  }, {
    "modelValue": {required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

function select(option: DrawerOption<U>): void {
  selected.value = option.value;
}

const selected = _useModel<U, U, U>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.vertical ? 'space-y-4' : 'flex space-x-8')
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
      return (_openBlock(), _createBlock(RadioButton, {
        title: option.title,
        selected: option.value === selected.value,
        onSelect: ($event: any) => (select(option))
      }, null, 8 /* PROPS */, ["title", "selected", "onSelect"]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})